import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    width: ['90%', '90%', '90%', '100%'],
    margin: [
      `${defaultTheme.spacing.l} auto 0`,
      `${defaultTheme.spacing.l} auto 0`,
      '0 auto',
      '0 auto',
    ],
  }),
);

export const TabHeading = styled.h1(() =>
  mq({
    flex: 1,
    textAlign: 'center',
    '& > button': {
      width: '100%',
    },
  }),
);

export const TabLink = TabHeading.withComponent(Link);
